module.exports = __webpack_public_path__ + "media/alert.cbb6064f.mp3";